// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1bah1y6m{justify-content:flex-start}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._2lx2vrvc{flex-direction:row}\n._kqswh2mm{position:relative}\n._lcxvglyw{pointer-events:none}\n._rjfvx6dd{-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory}", ""]);
// Exports
module.exports = exports;
